import { gql } from '../../../__generated__/graphql/catalog'

/**
 * Cart creation mutation for creating a cart w/items and taking a user to checkout.
 * @deprecated temporary version to support existing cart/checkout functionality prior to persistent cart.
 */
export const CHECKOUT_CART_CREATE = gql(`
  mutation checkoutCartCreate($input: CartInput!) {
    cartCreate(input: $input) {
      cart {
        id
        checkoutUrl
      }
      userErrors {
        code
        field
        message
      }
      warnings {
        code
        message
        target
      }
    }
  }
`)
